// templates/faq2
$('.questions li > a').on('click', function () {
  $(this).parent().toggleClass('on')
  return false
})
$('.sidebar a').on('click', function () {
  if (!$(this).is('.active')) {
    $('.sidebar a.active').removeClass('active')
    $('.questions .group.active').removeClass('active')
    $(this).addClass('active')
    index = $(this).parent().index()
    $('.questions .group').eq(index).addClass('active')
  }
  return false
})

// sections/timelineslideshow
$('.slideshow__slidesoutl').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  adaptiveHeight: true,
  prevArrow:
    "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
  nextArrow:
    "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
})

// sections/main-product
$('.product__media[data-slider2]').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: true,
  adaptiveHeight: true,
  draggable: false,
  prevArrow:
    '<button type="button" class="slick-prev pull-left"><img src="https://cdn.shopify.com/s/files/1/1250/5861/files/left-arrow_1.png?v=1669191200"></button>',
  nextArrow:
    '<button type="button" class="slick-next pull-right"><img src="https://cdn.shopify.com/s/files/1/1250/5861/files/next_1_1.png?v=1669191200"></button>',
})

$(document).on('click', '.customtabs0 div', function () {
  $('.customtabs0 li').removeClass('actived')
  var $this = $(this)
  setTimeout(function () {
    $this.parent().addClass('actived')
  }, 50)
  if ($(this).attr('data-indextbs') == '1') {
    $('.shwcntnt').removeClass('active')
    setTimeout(function () {
      $('.shwcntnt[data-indextbsa="1"]').addClass('active')
    }, 50)
  }
  if ($(this).attr('data-indextbs') == '2') {
    $('.shwcntnt').removeClass('active')
    setTimeout(function () {
      $('.shwcntnt[data-indextbsa="2"]').addClass('active')
    }, 50)
  }
  if ($(this).attr('data-indextbs') == '3') {
    $('.shwcntnt').removeClass('active')
    setTimeout(function () {
      $('.shwcntnt[data-indextbsa="3"]').addClass('active')
    }, 50)
  }
})
$(document).ready(function () {
  $('.imgprdmed').mousemove(function (e) {
    $('.imgprdmed2').css('height', $('.product__media').height() + 'px')
    $(this).children('img').hide()
    $(this).children('.zoom-wrap').removeClass('tw-hidden')
    $(this).find('.imgprdmed2').show()
    $(this)
      .find('.imgprdmed2')
      .css('height', $(this).height() + 'px')
  })
  $('.imgprdmed').mouseleave(function (e) {
    $('.imgprdmed').children('img').show()
    $('.imgprdmed').children('.zoom-wrap').addClass('tw-hidden')
    $('.imgprdmed').find('.imgprdmed2').hide()
  })

  $('.imgprdmed2').mousemove(function (e) {
    zoom(e)
  })

  function zoom(e) {
    var x, y
    var zoomer = e.currentTarget
    if (e.offsetX) {
      offsetX = e.offsetX
    } else {
      offsetX = e.touches[0].pageX
    }

    if (e.offsetY) {
      offsetY = e.offsetY
    } else {
      offsetX = e.touches[0].pageX
    }
    x = (offsetX / zoomer.offsetWidth) * 100
    y = (offsetY / zoomer.offsetHeight) * 100
    zoomer.style.backgroundPosition = x + '% ' + y + '%'
  }
})

var selIndex = Math.ceil(Math.random() * 4)
var arrColor = ['#FBC9C7', '#DFCEC6', '#D6E2F3', '#FECCD4']
jQuery(document).ready(function () {
  jQuery('.imgwtxt' + selIndex).addClass('imgwtxt-show')
  jQuery('.rich-text.s-inline-section').addClass('happiness' + selIndex)
  jQuery('.threesec' + selIndex).addClass('imgwtxt-show2')
})

$(window).scroll(function (event) {
  var scroll = $(window).scrollTop()
  if (scroll > 0) {
    $('.mega-nav__overlay').addClass('mega-nav__overlay0iop')
  } else {
    $('.mega-nav__overlay').removeClass('mega-nav__overlay0iop')
  }
})

$(document).on('click', '.scroll-to-form', function (event) {
  event.preventDefault()
  $('html, body').animate(
    {
      scrollTop: $(document).find('#wufoo-zb2oaas1vavo90').offset().top,
    },
    500
  )
})

let interval = setInterval(function () {
  if (document.querySelector('.rc_label__discount')) {
    $('.rc_label__discount').text($('.rc_label__discount').text().replace(')', ' off)'))
    clearInterval(interval)
  }
}, 100)
